import React from 'react'
import '../digital-portal.scss'
import { essilorLogo } from '@Techedge/digitalportal-styleguide'
import {
    LuxIcon,
    LuxButton,
    LuxHeading,
} from '@Techedge/digitalportal-wardrobe'
import { history } from '@Techedge/digitalportal-shared'
import { useParams } from 'react-router-dom'

const LoginError = (props) => {
    const errorType = (useParams() as any).auth
    const errorId = (useParams() as any).error_id

    let errorCode = ''

    switch (errorId) {
        case '_whoami':
            errorCode = '[001]'
            break
        case '_enabledapps':
            errorCode = '[002]'
            break
        case '_userstore':
            errorCode = '[003]'
            break
        case '_noportals':
            errorCode = '[004]'
            break

        default:
            break
    }

    const errorMsg1 =
        errorType == '_auth'
            ? 'It was not possible to recover the access permissions.'
            : 'You are not authorized to access the application.'
    const errorMsg2 =
        'If you consider this as a mistake, please, contact the Business Owner, ' +
        'System Administrator or open a ticket on the HelpDesk portal.'

    return (
        <div className="portal-container flex-center">
            <LuxButton
                icon={' cu cu-logout'}
                variant={['text']}
                text="Logout"
                classes="logout-btn"
                onClick={() => history.push('/logout')}
            />
            <i className="warning-icon cu cu-exclamation-triangle"></i>

            <img className="logo-bg" src={essilorLogo} />
            <img className="logo" src={essilorLogo} />
            <div className="text-box">
                <LuxHeading type="h2">{errorMsg1}</LuxHeading>
            </div>
            <p className="error-msg">
                {errorMsg2} {errorCode && <>{errorCode}</>}
            </p>
        </div>
    )
}

export default LoginError
